// Matches an HTML/XML-like tag, e.g. <h1>, </script>, <img src=x onerror=alert(1)>.
// Requires a letter immediately after '<' (or '</') so ordinary comparison
// operators in plain text, e.g. "cost < 5000", aren't misidentified as markup.
const HTML_TAG_PATTERN = /<\/?[a-zA-Z][a-zA-Z0-9]*(\s[^>]*)?>/

export const MARKUP_VALIDATION_MESSAGE =
  'Description cannot contain HTML tags or scripts. Please enter plain text only.'

export function containsMarkup(value: string): boolean {
  return HTML_TAG_PATTERN.test(value)
}
